import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicEditBrand({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fill="#4557a1"
        d="M15.53 4l-7.3 7.3-2.51.27a1.15 1.15 0 01-1.27-1.26l.28-2.51 7.3-7.3a1.62 1.62 0 012.3 0l1.2 1.2c.63.64.63 1.67 0 2.3zm-2.75.86l-1.61-1.61L6 8.4l-.2 1.81 1.8-.2 5.17-5.16zM7.5 1.25a.75.75 0 010 1.5h-5a.25.25 0 00-.25.25v10c0 .14.11.25.25.25h10c.14 0 .25-.11.25-.25V9.5a.75.75 0 111.5 0V13c0 .97-.78 1.75-1.75 1.75h-10c-.97 0-1.75-.78-1.75-1.75V3c0-.97.78-1.75 1.75-1.75zm5.47.2c.11-.12.3-.12.41 0l1.2 1.2a.3.3 0 010 .41l-.86.86-1.6-1.61z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicEditBrand.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicEditBrand.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicEditBrand svgRef={ref} {...props} />);
export default ForwardRef;
